import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import { getContent } from "../../../utilities/getContent/getContent";
import LanguagePicker from "../../../components/LanguagePicker/LanguagePicker";
const { REACT_APP_API_URL } = process.env;


const IndicatorViewer = ({ indicators, responseOptions }) => {
  const [selectedIndicatorId, setSelectedIndicatorId] = useState(null);
  const [showResponses, setShowResponses] = useState(true);

  const SingleQuestion = ({ question, responseOptions, index, showResponses }) =>
    <div>
      <p>{index + 1}. {getContent("question_" + question.questionId)} {showResponses ?
        (responseOptions.length > 0 ? responseOptions.map(r => <Badge key={r.field} color="primary" className="ms-2">{getContent(r.field)} ({r.value})</Badge>) : <Badge className="ms-2">No response</Badge>)
        : null}</p>
    </div>

  const selectedIndicator = selectedIndicatorId ? indicators.find(i => i.indicatorId === selectedIndicatorId) : null;
  return <Row>
    <Col lg="3">
      <h4>Indicators</h4>
      <ol>
        {indicators && indicators.map(i => <li className={i.indicatorId === selectedIndicatorId ? 'bg-warning' : ''} onClick={() => setSelectedIndicatorId(i.indicatorId)} data-id={i.indicatorId} key={i.indicatorId}>{i.displayAs} <i>{i.variant}</i></li>)}
      </ol>
    </Col>
    <Col lg="9">

      {selectedIndicator ?
        <div>
          <div className="float-right"><LanguagePicker /></div>
          <h3>{selectedIndicator.displayAs} <span className="fst-italic">{selectedIndicator.variant}</span></h3>
          <ul>
            <li>Type: {selectedIndicator.type}</li>
            <li>Interpretation: {selectedIndicator.interpretation}</li>
            <li>Score = {`${selectedIndicator.scoreRule.calc}(responses score)`} ; Thresholds: {Object.entries(selectedIndicator.scoreRule.index).map(([c, v]) => `${c} ${selectedIndicator.scoreRule.comp}${v}`).join(", ")}</li>
            <li>Range: {selectedIndicator.scoreRange?.min} - {selectedIndicator.scoreRange?.max}</li>
          </ul>
          <Form>
            <FormGroup
              check
              inline
            >
              <Input onChange={ (e)=> { setShowResponses(e.target.checked); }} type="checkbox" checked={showResponses}/>
              <Label check>
                Show Response Options
              </Label>
            </FormGroup>
          </Form>
          <h4>Questions</h4>
          {selectedIndicator.questions.map((q, idx) => <SingleQuestion
            key={q.questionId}
            question={q}
            index={idx}
            showResponses={showResponses}
            responseOptions={responseOptions.find(o => o.questionResponseOptionsTypeKey === q.questionResponseOptionsType)?.questionResponseOptionsTypeValue} />)}
          <hr />
          <h4>Questions B</h4>
          {selectedIndicator.questions_b.map((q, idx) => <SingleQuestion
            key={q.questionId}
            question={q}
            index={idx}
            showResponses={showResponses}
            responseOptions={responseOptions.find(o => o.questionResponseOptionsTypeKey === q.questionResponseOptionsType)?.questionResponseOptionsTypeValue} />)}
        </div>
        : <p>Select First</p>
      }
    </Col>
  </Row>
}

const AdminTools = () => {
  const [state, setState] = useState({ indicators: undefined, responseOptions: undefined })
  const API_TOKEN = useSelector(state => state.auth.idToken);
  useEffect(() => {
    axios({
      url: `${REACT_APP_API_URL}/survey/indicators?v2=true&questions=true`,
      method: 'GET',
      headers: { Authorization: API_TOKEN },
    }).then(res => {
      setState({ indicators: res.data.indicators.sort((i, j) => i.displayAs.localeCompare(j.displayAs)), responseOptions: res.data.responseOptions })
    })
  }, [])
  return <Container fluid>
    <IndicatorViewer {...state} />
  </Container>
}

export default AdminTools;